import React from "react";
import styles from "./EmployeeList.module.scss";

const SelectedDepartmentsChips = ({ selectedDepartments, onRemove }) => {
  const handleDeleteDepartment = (departmentName) => {
    onRemove(departmentName);
  };

  return (
    <div className={styles.selectedChips}>
      {selectedDepartments.map((department) => (
        <div key={department} className={styles.departmentChip}>
          {department}
          <span
            className={styles.removeChip}
            onClick={(clickEvent) =>
              handleDeleteDepartment(department, clickEvent)
            }
          >
            ×
          </span>
        </div>
      ))}
    </div>
  );
};

export default SelectedDepartmentsChips;
